<template>
  <div class="noticeItem" @click="itemClick">
    <div class="left">
      <el-avatar :size="32" :src="$oss + item.fromAvatar" />
      <div class="isDot" v-show="item.unread"></div>
    </div>
    <div class="right">
      <div class="right_top">
        <div class="name">{{ item.fromName }}</div>
        <div class="time">{{ item.createdAt | timeFormat("yyyy-mm-dd hh:MM:ss") }}</div>
      </div>
      <div class="right_bottom keep2lines">
        <span class="front" v-if="item.type == 4">回复</span
        ><span class="front" v-if="item.type == 3">评论</span>
        {{ item.content }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
export default {
  props: {
    item: {
      type: Object,
      default: () => ({
        notificationId: null,
        type: null,
        content: "",
        fromName: "",
        fromAvatar: "",
        unread: null,
        empName: "",
        empAvatar: "",
        originId: null,
        empId: null,
        createdAt: null,
      }),
    },
  },
  components: {},
  data() {
    return {};
  },
  created() {},
  computed: {},
  methods: {
    ...mapActions("notice", ["putNotification"]),
    ...mapMutations("notice", ["setNoticeVisible"]),
    ...mapActions("information", ["detailOnShow"]),
    itemClick() {
      const { notificationId, type,messageId } = this.item;
      this.putNotification({ notificationId });
      this.setNoticeVisible(false);
      if (type == 1) {
        this.$router.push({
          path: "/Information/InformationMy",
          query: {
            status: 1,
          },
        });
        return;
      }
      if (type == 2) {
        this.$router.push({
          path: "/Information/InformationMy",
          query: {
            status: 2,
          },
        });
        return;
      }
      if([3,4].includes(type)){
        this.showMessage(messageId);
        return
      }
    },
    showMessage(id) {
       this.detailOnShow(id);
    },
  },
};
</script>

<style scoped lang="scss">
.noticeItem {
  padding: 16px;
  display: flex;
  gap: 10px;
  .left {
    flex-shrink: 0;
    position: relative;
    .isDot {
      width: 7px;
      height: 7px;
      border-radius: 100%;
      background: #ff0d0d;
      border: 1px solid #ffffff;
      position: absolute;
      right: 0;
      top: 0;
    }
  }
  .right {
    flex: 1;
    &_top {
      display: flex;
      justify-content: space-between;
      .name {
        font-size: 14px;
        color: #262626;
        font-weight: 500;
      }
      .time {
        font-size: 12px;
        color: #999999;
      }
    }
    &_bottom {
      margin-top: 4px;
      font-size: 14px;
      line-height: 24px;
      color: #262626;
      .front {
        color: #999999;
      }
    }
  }
}
</style>
